import Log from '../lib/log';
import { v2api } from '../api/axios';
import { setupUserType } from '../store/setupUserSlice';

// ログの初期化
const log = new Log('UpgradeUser');

// 入力値のチェック
const checkStoreData = (storeData: setupUserType) => {
  console.log(`🐞 storeData: ${JSON.stringify(storeData, null, '\t')}`);
  let confirm = true;
  if (
    !storeData.id ||
    !storeData.nickname ||
    !storeData.email ||
    !storeData.stripeCardTokenId ||
    !storeData.responseText ||
    !storeData.userNumber ||
    !storeData.token
  )
    confirm = false;
  return confirm;
};

// 050番号の取得
const getServiceNumber = async (storeData: setupUserType) => {
  console.log(`🐞 getServiceNumber start.`);
  let serviceNumber = '';

  try {
    const postData = {
      userId: storeData.id,
      token: storeData.token,
    };
    const res = await v2api.post('/update-service-number', postData);
    if (res.data.statusCode !== 200) {
      throw new Error(`update-service-number error: ${res.data.statusCode}`);
    }
    serviceNumber = JSON.parse(res.data.body).service_number;
  } catch (err: any) {
    log.putLog('error', err.message ? err.message : err);
  }

  return serviceNumber;
};

// 応答メッセージの生成
const createResponseMessage = async (storeData: setupUserType) => {
  console.log(`🐞 createResponseMessage start.`);
  let completed = true;

  try {
    const postData = {
      userId: storeData.id,
      token: storeData.token,
      text: storeData.responseText,
      voiceType: storeData.responseVoiceType.toString(),
    };
    const res = await v2api.post('/change-response', postData);
    if (res.data.statusCode !== 200) {
      completed = false;
      throw new Error(`change-response error: ${res.data.statusCode}`);
    }
  } catch (err: any) {
    log.putLog('error', err.message ? err.message : err);
    completed = false;
  }

  return completed;
};

// Stripeデータの生成
const createStripeCustomer = async (storeData: setupUserType) => {
  console.log(`🐞 createStripeCustomer start.`);
  let completed = true;

  try {
    const postData = {
      userId: storeData.id,
      token: storeData.token,
      tokenId: storeData.stripeCardTokenId,
    };
    const res = await v2api.post('/create-stripe-customer', postData);
    if (res.data.statusCode !== 200) {
      completed = false;
      throw new Error(`create-stripe-customer error: ${res.data.statusCode}`);
    }
  } catch (err: any) {
    log.putLog('error', err.message ? err.message : err);
    completed = false;
  }

  return completed;
};

// ユーザーデータの作成
// APIキーの発行と紹介ボーナスの付与はサーバー側（update-db の completeSetup）で行う
const updateUser = async (storeData: setupUserType) => {
  console.log(`🐞 updateUser start.`);
  let completed = true;

  try {
    const postData = {
      userId: storeData.id,
      token: storeData.token,
      action: 'completeSetup',
      input: {
        user_name: storeData.nickname,
        add_message: storeData.addMessage,
        invitation_code: storeData.invitationCode || undefined,
        recipients: [
          {
            address: storeData.email,
            attach_media: storeData.attachMedia,
            in_message: storeData.inMessage,
            incoming_notice: storeData.incomingNotice,
          },
        ],
      },
    };
    const res = await v2api.post('/update-db', postData);
    if (res.data.statusCode !== 200) {
      completed = false;
      throw new Error(`update-db error: ${res.data.statusCode}`);
    }
  } catch (err: any) {
    log.putLog('error', err.message ? err.message : err);
    completed = false;
  }

  return completed;
};

export default function upgradeUser(setupUser: setupUserType): Promise<string> {
  log.putLog('info', 'UpgradeUser started.');

  return new Promise((resolve, reject) => {
    (async () => {
      // 入力値のチェック
      if (!checkStoreData(setupUser)) {
        log.putLog('error', 'Invalid Setup data.');
        return reject('Invalid Setup data.');
      }

      // 応答メッセージの作成
      if (!(await createResponseMessage(setupUser))) {
        log.putLog('error', 'Create response message failed.');
        return reject('Create response message failed.');
      }

      // Stripeの作成
      if (!(await createStripeCustomer(setupUser))) {
        log.putLog('error', 'Create stripe customer failed.');
        return reject('Create stripe customer failed.');
      }

      // Twilio番号の購入
      const serviceNumber = await getServiceNumber(setupUser);
      if (serviceNumber === '') {
        log.putLog('error', 'Get number failed.');
        return reject('Get number failed.');
      }

      // userの更新
      if (!(await updateUser(setupUser))) {
        log.putLog('error', 'Update user failed.');
        return reject('Update user failed.');
      }

      resolve(serviceNumber);
    })();
  });
}
